// 搜索结果点击下载下方弹出推荐应用
import React, { memo, useCallback, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { createSelector } from 'reselect';
import { logging, logPostInfo } from '../../actions/log';
import { CONTEXT } from '../../config';
import Rate from '../Rate/Rate';
import Button from '../Button/Button';
import ApkButton from '../Button/Button';
import styles from './SoftCardRank4.module.less';
import { hasClass, removeClass, addClass } from '../../utils/utils';
import _LogInView from '../_LogInView/_LogInView';

const selectLogInfo = createSelector(
  state => state.log,
  log => log.logInfo,
);
export default memo(({ soft, logInfo }) => {
  const dispatch = useDispatch();
  const history = useHistory();
  const logInfoData = useSelector(selectLogInfo);
  const optRef = useRef(null);

  const handleSoftCard = useCallback(() => {
    // 小banner点击
    dispatch(
      logging({
        category: 'C',
        action: 'handle_SoftCard',
        label: '',
        param2: {
          ...logInfo,
          source: logInfo.source,
          source_p: logInfoData.source_p,
          source_pp: logInfoData.source_pp,
        },
        param3: soft.bizInfo,
      }),
    );
    dispatch(
      logPostInfo({
        source_p: logInfo.source || 'SoftCardRank_Source_Err',
        source_pp: logInfoData.source_p,
      }),
    );

    if (soft.androidType === '1') {
      history.push(
        `${CONTEXT}/adetail/${soft.packageName}/${soft.versionCode}/${soft.bizInfo || '{}'}`,
      );
    } else {
      history.push(`${CONTEXT}/detail/soft/${soft.softID}/${soft.bizInfo || '{}'}`);
    }
  }, [dispatch, logInfo, history]);

  const onMouseOver = useCallback(
    e => {
      if (optRef && optRef.current) {
        const optDom = optRef.current;
        addClass(optDom, styles.mouse_in);
      }
    },
    [optRef],
  );

  const onMouseLeave = useCallback(e => {
    if (optRef && optRef.current) {
      const optDom = optRef.current;
      addClass(optDom, styles.mouse_out);
    }
  }, []);

  const onAnimationEnd = useCallback(e => {
    if (optRef && optRef.current) {
      const optDom = optRef.current;
      if (hasClass(optDom, styles.mouse_out)) {
        removeClass(optDom, styles.mouse_in);
        removeClass(optDom, styles.mouse_out);
      }
    }
  }, []);

  return (
    <_LogInView cardData={soft} logInfo={logInfo}>
      <div
        className={styles.soft_card}
        onMouseOver={e => onMouseOver(e)}
        onMouseLeave={e => onMouseLeave(e)}
        onAnimationEnd={e => onAnimationEnd(e)}
        onClick={() => {
          handleSoftCard(soft);
        }}
      >
        <div className={styles.soft_card_img_box}>
          <img className={styles.soft_card_img} src={soft.logoFile} alt="" />
          {soft.androidType === '1' && <div className={styles.soft_card_logo} />}
        </div>
        <div className={styles.soft_card_infos}>
          <div
            className={styles.soft_card_title}
            dangerouslySetInnerHTML={{ __html: soft.softName }}
            title={(soft.softName && soft.softName.length) > 8 ? soft.softName : ''}
          />
          <div className={styles.soft_card_desc}>{soft.introduction || ''}</div>
          <div
            className={styles.soft_card_opt}
            ref={optRef}
            onClick={e => {
              e.stopPropagation();
            }}
          >
            {soft.androidType === '1' ? (
              <ApkButton
                soft={soft}
                info={{
                  className: styles.soft_button,
                  className_busing: styles.soft_button_busing,
                  className_open: styles.soft_button_open,
                }}
                logInfo={{ ...logInfo }}
              />
            ) : (
              <Button
                soft={soft}
                info={{
                  className: styles.soft_button,
                  className_busing: styles.soft_button_busing,
                  className_open: styles.soft_button_open,
                }}
                logInfo={{ ...logInfo }}
              />
            )}
          </div>
        </div>
      </div>
    </_LogInView>
  );
});
